import {IMqttMessage} from 'ngx-mqtt';
import {Subscription} from 'rxjs';

export abstract class AbstractMqttService {
  abstract subscribe(
    topic: string, next?: (value: IMqttMessage) => void, error?: (error: unknown) => void, complete?: () => void
  ): Subscription;

  abstract unsubscribe(topic: string): void;

  abstract isSubscribed(topic: string): boolean;

  abstract inicializar(): void;
}

export class FakeMqttService implements AbstractMqttService {

  private subs: { [key: string]: Subscription } = {};

  subscribe(topic: string, next?: (value: IMqttMessage) => void, error?: (error: unknown) => void, complete?: () => void)
    : Subscription {
    const topicName = `${topic.replace(/\./g, '/')}`;

    if (!this.isSubscribed(topic)) {
      this.subs[topicName] = new Subscription();
    }

    return this.subs[topicName];
  }

  unsubscribe(topic: string): void {
    const topicName = `${topic.replace(/\./g, '/')}`;

    if (this.subs[topicName]) {
      this.subs[topicName].unsubscribe();
    }
  }

  isSubscribed(topic: string): boolean {
    const topicName = `${topic.replace(/\./g, '/')}`;

    return !!this.subs[topicName];
  }

  inicializar(): void {
  }
}

